import { render, staticRenderFns } from "./ListaTopo.vue?vue&type=template&id=4be16514&scoped=true"
import script from "./ListaTopo.vue?vue&type=script&lang=js"
export * from "./ListaTopo.vue?vue&type=script&lang=js"
import style0 from "./ListaTopo.vue?vue&type=style&index=0&id=4be16514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be16514",
  null
  
)

export default component.exports